import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IProductSearch_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProductSearch_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class ProductSearch_ScreenBase extends React.PureComponent<
  IProductSearch_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  productsearch_763103_value_kuikaSelectBoxRef: React.RefObject<any>;
  productsearch_627596_value_kuikaSelectBoxRef: React.RefObject<any>;
  productsearch_225707_value_kuikaTableRef: React.RefObject<any>;
  productsearch_234938_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "dd183118-7165-4123-b55c-e7f2349118bc",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 24291, PropertyName: "value", Value: "Ürün Sorgulama" },
        { Id: 854780, PropertyName: "placeholder", Value: "Barkod Giriniz..." },
        { Id: 236556, PropertyName: "value", Value: "Ürün Ara" },
        { Id: 766204, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 132328, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 699672, PropertyName: "value", Value: "Özellik1" },
        { Id: 763103, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 569251, PropertyName: "value", Value: "Özellik2" },
        { Id: 627596, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 716901, PropertyName: "label", Value: "Temizle" },
        { Id: 35840, PropertyName: "label", Value: "Ara" },
        { Id: 326212, PropertyName: "title", Value: "Title" },
        { Id: 23798, PropertyName: "value", Value: "Ürün Kodu" },
        { Id: 169232, PropertyName: "value", Value: "label" },
        { Id: 952020, PropertyName: "value", Value: "Ürün Adı" },
        { Id: 20203, PropertyName: "value", Value: "label" },
        { Id: 599994, PropertyName: "value", Value: "label" },
        { Id: 511920, PropertyName: "value", Value: "Satın Alma Fiyatı" },
        { Id: 55242, PropertyName: "value", Value: "label" },
        { Id: 541080, PropertyName: "value", Value: "Satış Fiyatı" },
        { Id: 212883, PropertyName: "value", Value: "label" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.productsearch_854780_value_kuikaTextInputRef = React.createRef();
    this.productsearch_910294_value_kuikaTextInputRef = React.createRef();
    this.productsearch_81551_value_kuikaTextInputRef = React.createRef();
    this.productsearch_763103_value_kuikaSelectBoxRef = React.createRef();
    this.productsearch_627596_value_kuikaSelectBoxRef = React.createRef();
    this.productsearch_225707_value_kuikaTableRef = React.createRef();
    this.productsearch_234938_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "productsearch",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "productsearch",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "productsearch",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
